
import { useAuth } from "@/components/AuthProvider";
import { ProfileAvatar } from "./ProfileAvatar";
import { ProfileInfoForm } from "./ProfileInfoForm";

export const ProfileForm = () => {
  const { profile, user } = useAuth();
  
  if (!profile || !user) return null;
  
  return (
    <div className="space-y-8">
      <ProfileAvatar profile={profile} user={user} />
      <ProfileInfoForm profile={profile} user={user} />
    </div>
  );
};
